import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { useEffect } from 'react';
/* import { TUpdate } from 'domain/types';
import {
  GlobalConfigContext,
  TGlobalConfigContextState,
} from 'domain/globalConfig/GlobalConfigContext';
import { useContextSelector as useCS } from 'use-context-selector';
import { globalConfigSelectors } from 'domain/globalConfig/selectors'; */

export const useSendMessage = (getChatsList) => {
  /* const globalUpdate: TUpdate<TGlobalConfigContextState> | undefined = useCS(
    GlobalConfigContext,
    globalConfigSelectors.update
  );
  const messages: any = useCS(GlobalConfigContext, globalConfigSelectors.messages); */

  const { data, isLoading, error, send } = useRequest({
    url: '/api/v1/message',
    method: ApiMethodsEnum.Post,
    sendOnStart: false,
    chatService: true,
  });

  const sendMessage = (body: any) => {
    send(body).then();
  };

  useEffect(() => {
    if (!isLoading && !error && data) {
      getChatsList();
      /* if (globalUpdate) globalUpdate({ messages: [...messages, data] }); */
    }
  }, [data, error, isLoading]);

  return {
    sendMessage,
    data,
    isLoading,
    error,
  };
};
